import React from "react";
import { Typography } from "src/components/new/Typography";

interface PreferencesSectionProps {
  items: { label: string; value: React.ReactNode }[];
}

const PreferencesSection = ({ items }: PreferencesSectionProps) => {
  return (
    <>
      <Typography
        sx={{
          marginTop: '0.9375rem',
          marginBottom: '0.9375rem',
          fontWeight: '600',
        }}
      >
        Preferences
      </Typography>
      <div
        style={{
          padding: '0.9375rem',
          border: '0.0625rem solid #cac4d0',
          borderRadius: '0rem',
        }}
      >
        {items.map(
          (section) =>
            section.value && (
              <Typography key={section.label} sx={{ marginBottom: '0.75rem' }}>
                <span style={{ fontWeight: '500' }}>{section.label}: </span>
                {section.value}
              </Typography>
            ),
        )}
      </div>
    </>
  );
};

export default PreferencesSection;